<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<div class="table-container">
    <!--    Шапка с табами    -->
    <div class="widget-container head-grid-tab"
         [class.selected]="mainTabs === 'clients'"
         (click)="changeMainTab('clients')"
    >
        <div class="widget-body">
            <div class="main-tab-grid-header">
                <h2>{{ 'INDEX_PAGE.OFFICE.TABS.CLIENTS' | translate }} </h2>
                <div class="circle-container">
                    @if (statisticData) {
                        <span>
                            {{ statisticData.clients }}
                        </span>
                    } @else {
                        N/A
                    }
                </div>
            </div>
            <div class="bubble-container">
                <button [class.selected]="clientsTab === 'legal'"
                        (click)="clientsTab = 'legal'"
                >
                    {{ 'INDEX_PAGE.OFFICE.BUBBLES_TEXT.LEGAL' | translate }}
                </button>
                <button [class.selected]="clientsTab === 'individual'"
                        (click)="clientsTab = 'individual'"
                >
                    {{ 'INDEX_PAGE.OFFICE.BUBBLES_TEXT.INDIVIDUAL' | translate }}
                </button>
            </div>
        </div>
    </div>
    <div class="widget-container head-grid-tab"
         [class.selected]="mainTabs === 'members'"
         (click)="changeMainTab('members')"
    >
        <div class="widget-body">
            <div class="main-tab-grid-header">
                <h2>{{ 'INDEX_PAGE.OFFICE.TABS.MEMBERS' | translate }} </h2>
                <div class="circle-container">
                    @if (statisticData) {
                        <span>
                            {{ statisticData.all_members }}
                        </span>
                    } @else {
                        <ng-container *ngTemplateOutlet="loading"></ng-container>
                    }
                </div>
            </div>
            <div class="bubble-container">
                <button [class.selected]="membersTab === 'staff'"
                        (click)="membersTab = 'staff'"
                >
                    {{ 'INDEX_PAGE.OFFICE.BUBBLES_TEXT.STAFF' | translate }}
                </button>
                <button [class.selected]="membersTab === 'outStaff'"
                        (click)="membersTab = 'outStaff'"
                >
                    {{ 'INDEX_PAGE.OFFICE.BUBBLES_TEXT.OUT_STAFF' | translate }}
                </button>
            </div>
        </div>
    </div>
    <div class="widget-container head-grid-tab"
         [class.selected]="mainTabs === 'structure'"
         (click)="changeMainTab('structure')"
    >
        <div class="widget-body">
            <div class="main-tab-grid-header">
                <h2>{{ 'INDEX_PAGE.OFFICE.TABS.STRUCTURE' | translate }}</h2>
            </div>
            <div class="bubble-container">
                <button [class.selected]="structureTab === 'horizontally'"
                        (click)="structureTab = 'horizontally'"
                >
                    {{ 'INDEX_PAGE.OFFICE.BUBBLES_TEXT.HORIZONTALLY' | translate }}
                </button>
                <button [class.selected]="structureTab === 'vertically'"
                        (click)="structureTab = 'vertically'"
                        disabled
                >
                    {{ 'INDEX_PAGE.OFFICE.BUBBLES_TEXT.VERTICALLY' | translate }}
                </button>
            </div>
        </div>
    </div>
    <!--  Шапка END  -->

    @switch (mainTabs) {
        @case ('clients') {

        }
        @case ('members') {
            <div class="widget-container column-3">
                @if (allMembers) {
                    <div class="widget-header">
                        <div class="search"
                             (click)="searchInput.focus()"
                        >
                            <i class="ri-search-line"></i>
                            <input type="search"
                                   placeholder="{{ 'INDEX_PAGE.OFFICE.TEXT.SEARCH' | translate }}"
                                   (input)="searchInMembers(searchInput.value)"
                                   #searchInput
                            >
                        </div>

                        <i class="ri-refresh-line"
                           (click)="getAllMembers(); searchInput.value = null"
                        ></i>
                    </div>
                    <div class="widget-body">
                        <section class="members_table">
                            <table mat-table
                                   [dataSource]="allMembers[membersTab]"
                            >
                                <!-- avatar Column -->
                                <ng-container matColumnDef="avatar">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    ></th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                        [width]="36"
                                    >
                                        <app-avatar
                                                [size]="'mini'"
                                                [profile]="element"
                                        ></app-avatar>
                                    </td>
                                </ng-container>

                                <!-- фио Column -->
                                <ng-container matColumnDef="full_name">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        {{ 'INDEX_PAGE.OFFICE.TEXT.FULL_NAME' | translate }}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                        (click)="helper.openProfileByGuid(element.guid)"
                                    >
                                        <span class="user_profile">
                                            {{ helper.fullName(element) }}
                                        </span>
                                    </td>
                                </ng-container>

                                <!-- email Column -->
                                <ng-container matColumnDef="email">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        Email
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        {{ element.email }}
                                    </td>
                                </ng-container>

                                <!-- position Column -->
                                <ng-container matColumnDef="position">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        {{ 'INDEX_PAGE.OFFICE.TEXT.POSITION' | translate }}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        {{ element.project_setting.position ?? '-' }}
                                    </td>
                                </ng-container>

                                <!-- join_date Column -->
                                <ng-container matColumnDef="join_date">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        {{ 'INDEX_PAGE.OFFICE.TEXT.JOIN_DATE' | translate }}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                    <span> {{ element.project_setting.join_date | date:'dd.MM.yy' }}
                                        <span class="dt__time">
                                            {{ element.project_setting.join_date | date:'HH:mm' }}
                                        </span>
                                    </span>
                                    </td>
                                </ng-container>

                                <tr mat-header-row
                                    *matHeaderRowDef="['avatar', 'full_name', 'email', 'position', 'join_date'], sticky: true"
                                ></tr>
                                <tr mat-row
                                    *matRowDef="let row; columns: ['avatar', 'full_name', 'email', 'position', 'join_date'];"
                                ></tr>
                                <tr class="mat-row"
                                    *matNoDataRow
                                >
                                    <td class="mat-sell"
                                        colspan="4"
                                    >
                                        <strong>{{ 'EMPTY_LISTS.MEMBERS' | translate }}</strong>
                                    </td>
                                </tr>
                            </table>
                        </section>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>
        }
        @case ('structure') {
            @if (columns) {
                <div class="tree">
                    <div class="columns">
                        @for (col of columns; track $index; let level = $index) {
                            <div class="column">
                                @for (item of col; track $index) {
                                    <div class="node"
                                         [class.active]="path[level] === (item.department_id ?? item.id)"
                                         (click)="onSelect(item, level)"
                                    >
                                        <div class="name">
                                            {{ item.department_name || item.name }}
                                        </div>

                                        <div class="count">
                                            <span [matTooltip]="'INDEX_PAGE.OFFICE.TEXT.MEMBERS_COUNT' | translate">
                                                {{ item?.member_guids?.length ?? 0 }}
                                            </span>
                                            @if (getChildren(item)?.length) {
                                                <i class="ri-arrow-right-line"></i>
                                            }
                                        </div>
                                    </div>
                                    @if (path.length && item.id && path[level] === item.id) {
                                        <div class="member-container">
                                            <h2>{{ 'INDEX_PAGE.OFFICE.TEXT.MEMBER_LIST' | translate }}</h2>
                                            @for (memberGuid of item.member_guids; track memberGuid) {
                                                <div class="member-item">
                                                    <app-avatar
                                                            [profile]="departmentsMembers[memberGuid]"
                                                            [size]="'mini'"
                                                    ></app-avatar>
                                                    <span class="user_profile"
                                                          (click)="helper.openProfileByGuid(memberGuid)"
                                                    >
                                                        {{ helper.shortFullName(departmentsMembers[memberGuid]) }}
                                                    </span>
                                                </div>
                                            } @empty {
                                                <span>{{ 'EMPTY_LISTS.MEMBERS' | translate }}</span>
                                            }
                                        </div>
                                    }
                                }
                            </div>
                        }

                    </div>
                </div>
            } @else {
                <ng-container *ngTemplateOutlet="loading"></ng-container>
            }
        }
    }
</div>
